<div  fxLayout.lt-md="column" fxLayoutAlign.lt-md="center center" [fxLayout]="fxLayout" fxLayoutAlign="center start"  fxFlex="100" fxLayoutGap="24px" class="scroll-margin-bottom">
  <ng-content></ng-content>
</div>